// Import Moment JS
import moment from 'moment';

/**
 * Format data
 * @param {DateTime(date)}
 * @returns {Date}
 */
export const formatDate=(date) =>{
  return moment(date).format('YYYY/MM/DD HH:mm');
}

/**
 * Format Price
 * @param {Int(value)}
 * @returns {String}
 */
export const formatPrice =(value) => {
  let formatter = new Intl.NumberFormat('ja-JP', {
    style: 'currency',
    currency: 'JPY',
    minimumFractionDigits: 0,
  });
  return formatter.format(value);
}

/**
 * Format User Name
 * @param {Array(user)}
 * @returns {String}
 */
export const formatUserName =(user) => {
  let user_name = "";
  if(user.user_profile){
    if(user.user_profile.first_name || user.user_profile.last_name){
      const f_name = user.user_profile.first_name? user.user_profile.first_name+" ":"" ;
      const l_name = user.user_profile.last_name?user.user_profile.last_name:"";
      user_name = f_name + l_name;
    }else{
      user_name = user.email
    }
  }else{
    user_name = user.email
  }
  return user_name;
}

/**
 * Get Client Attributes
 * @returns {Array}
 */
 export const getClientAttributes = () => {
  return [
    {
      value: null,
      text: '属性を選択してください',
      disabled: true,
    },
    {
      value: 'Real estate management company',
      text: '不動産管理会社',
    },
    {
      value: 'Real estate agent',
      text: '不動産仲介業者',
    },
    {
      value: 'Real estate owner',
      text: '不動産オーナー',
    },
    {
      value: 'Others',
      text: 'その他',
    },
  ];
}

/**
 * Get Floor plan types
 * @returns {Array}
 */
 export const getFloorPlanTypes = () => {
  return [
    {
      value: null,
      text: '間取りタイプを選択してください',
      disabled: true,
    },
    {
      value: 'ワンルーム',
      text: 'ワンルーム',
    },
    {
      value: '1K',
      text: '1K',
    },
    {
      value: '1DK',
      text: '1DK',
    },
    {
      value: '1LDK',
      text: '1LDK',
    },
    {
      value: '2K',
      text: '2K',
    },
    {
      value: '2DK',
      text: '2DK',
    },
    {
      value: '2LDK',
      text: '2LDK',
    },
    {
      value: '3K',
      text: '3K',
    },
    {
      value: '3DK',
      text: '3DK',
    },
    {
      value: '3LDK',
      text: '3LDK',
    },
    {
      value: '4K',
      text: '4K',
    },
    {
      value: '4DK',
      text: '4DK',
    },
    {
      value: '4LDK',
      text: '4LDK',
    },
    {
      value: '5K以上',
      text: '5K以上',
    },

  ];
}

/**
 * Get Building Type
 * @returns {Array}
 */
 export const getBuildingType = () => {
  return [
    {
      value: null,
      text: '建物の種類を選択してください',
      disabled: true,
    },
    {
      value: 'マンション',
      text: 'マンション',
    },
    {
      value: 'アパート',
      text: 'アパート',
    },
    {
      value: '戸建住宅',
      text: '戸建住宅',
    },
    {
      value: 'その他',
      text: 'その他',
    },
  ];
}

/**
 * Get Managed Property Numbers
 * @returns {Array}
 */
 export const getManagedPropertyNumbers = () => {
  return [
    {
      value: null,
      text: '管理物件数を選択してください',
      disabled: true,
    },
    {
      value: '1-200',
      text: '1-200',
    },
    {
      value: '201-1000',
      text: '201-1000',
    },
    {
      value: '1001-2000',
      text: '1001-2000',
    },
    {
      value: '2001-4000',
      text: '2001-4000',
    },
    {
      value: '4001-6000',
      text: '4001-6000',
    },
    {
      value: '6001-10000',
      text: '6001-10000',
    },
    {
      value: '10000以上',
      text: '10000以上',
    },
  ];
}

/**
 * Get Gender
 * @returns {Array}getCoupon
 */
 export const getGender = () => {
  return [
    {
      value: null,
      text: '性別を選択してください',
      disabled: true,
    },
    {
      value: 'Male',
      text: '男性',
    },
    {
      value: 'Female',
      text: '女性',
    },
    {
      value: 'I prefer not to say',
      text: '未回答',
    },
  ];
}

/**
 * Get Gender
 * @returns {Array}
 */
 export const getCoupon = () => {
  return [
    {
      value: null,
      text: '利用制限を選択してください',
      disabled: true,
    },
    {
      value: 'Can only be used once',
      text: '一回しか使えない',
    },
    {
      value: 'Can be used multiple times',
      text: '複数回利用可能',
    },
    {
      value: 'Can be used any number of times during the period',
      text: '期間中何回でも利用可能',
    },
  ];
}

/**
 * Get Invoice
 * @returns {Array}
 */
export const getInvoice = () => {
  return [
    {
      value: '0',
      text: 'クレジット払い',
    },
    {
      value: '1',
      text: '請求書払い',
    },
  ];
}

/**
 * Get Inquiry Type
 * @returns {Array}
 */
 export const getInquiryTypes = () => {
  return [
    {
      value: null,
      text: 'お問い合わせ種別を選択',
      disabled: true,
    },
    {
      value: 'アカウントについて',
      text: 'アカウントについて',
    },
    {
      value: 'ステージング依頼の状況について',
      text: 'ステージング依頼の状況について',
    },
    {
      value: '課金について',
      text: '課金について',
    },
    {
      value: 'メディア・取材について',
      text: 'メディア・取材について',
    },
    {
      value: 'その他',
      text: 'その他',
    },
  ];
}
